import $http from '../api/http'
import filter from '../utils/filter';

const statement = {
  // 获取短信发送清单
  async getStatement (params) {
    const filterParams = filter(params);
    return $http('/api/messages', {
      method: 'GET',
      params: { ...filterParams }
    });
  },
  // 获取国际短信发送清单
  async getGlobalStatement (params) {
    const filterParams = filter(params);
    return $http('/api/messages/intl', {
      method: 'GET',
      params: { ...filterParams }
    });
  },
  async getUpStreamStatement (params) {
    return $http('/api/mo', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  async getDataReview (params) {
    return $http('/api/messages/stats', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  async getFailureAnalysis (params) {
    return $http('/api/messages/errors', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  async getPn (params) {
    return $http('/api/detection/pn/statistics', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  async getError (code) {
    return $http(`/api/errors-docs/keys/${code}`, {
      method: 'GET'
    });
  },
  // 定时发送
  async getTasks (params) {
    return $http('/api/messages/async/tasks', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  // 取消发送
  async handleCancel (params, task_id) {
    return $http(`/api/messages/async/tasks/${task_id}`, {
      method: 'PATCH',
      data: { ...filter(params) }
    });
  },
  // 获取超级短信发送明细
  async getMmsStatement (params) {
    return $http('/api/mms/messages', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  // 获取cmpp账号
  async getCmppAccounts (params) {
    return $http('/api/cmpp/accounts?page=1', {
      method: 'GET',
      params: { ...filter(params) }
    });
  }
};

export default statement;



// WEBPACK FOOTER //
// ./src/api/statement.js